import { ol_Feature, ol_style } from "@omnia/exports/openlayers";
import { Datalayer, DatalayerZone, mapStyles } from "../omnia";
import { IDataLayerZone } from "../types";
import { SoilAnalysisZone } from "./soilAnalysisZone";


export class SoilAnalysisLayer extends Datalayer {

    public showAllAnalysis: boolean;


    getTooltipTemplate(feature: any, data: any, editMode: boolean): string {
        return "app/soil/map/zoneTooltip.html";
    }

    get valueEditTemplate(): string {
        return "app/soil/map/zoneEditInclude.html";
    }

    protected createZoneInstance(zone: IDataLayerZone): DatalayerZone {
        return new SoilAnalysisZone(this, zone);
    }

    protected getZonePointStyle(feature: ol_Feature, zone: DatalayerZone, selected: boolean, resolution: number): ol_style.Style[] {

        if ((resolution <= 5) && (zone instanceof SoilAnalysisZone)) {

            let location = zone.getLocationGeom();

            if (location) {

                let width = 2;

                let styles = [
                    new ol_style.Style({
                        geometry: location,
                        image: new ol_style.Circle({
                            radius: width * 2,
                            fill: new ol_style.Fill({
                                color: [255, 255, 255, 1]
                            }),
                            stroke: new ol_style.Stroke({
                                color: mapStyles.red,
                                width: width / 1.5
                            })
                        }),
                    })
                ];


                return styles;

            }


        }

        return super.getZonePointStyle(feature, zone, selected, resolution);

    }

    getSnappingFeatures() {

        let features = super.getSnappingFeatures() || [];

        if (this.zones) {

            let points = this.zones.map(z => {

                if (z instanceof SoilAnalysisZone) {
                    let point = z.getLocationGeom();
                    if (point) {
                        return new ol_Feature(point);
                    }
                }
            }).filter(p => !!p);

            features = features.concat(points);

        }

        return features;

    }

    protected getTextStyles(zone: DatalayerZone, resolution: number, offsetY: number) {

        let styles = super.getTextStyles(zone, resolution, offsetY);

        if (zone instanceof SoilAnalysisZone) {

            let point = zone.getLocationGeom();

            if (point) {

                styles.forEach(s => {
                    s.setGeometry(point)
                    let text = s.getText();
                    text.setOffsetY((text.getOffsetY() || 0) + 25);
                });
            }

        }

        return styles;

    }

}
